import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  products: {
    height: '27.697916666667vh',
    padding: '0 1.5vw',
    marginBottom: '1.17vh',
    '@media  (width: 1024px) and (height: 576px)': {
      height: '29.697916666667vh',
    },
  },
  controls: {
    height: '7.81vh',
    padding: '0 1.7vw',
    width: '100%',
  },
  tenderListContainer: {
    backgroundColor: themeColor.white,
    marginBottom: 10,
    flexGrow: 1,
  },
}));
